var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrismaPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.3,
    stroke: "#B9986A",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1941 25.1993L15.3868 10.6092C15.0908 10.1172 14.5688 9.81836 14.0069 9.81836H11.1798C11.0624 9.81836 10.9488 9.89306 10.9188 10.0116C10.8813 10.1584 10.97 10.3013 11.1048 10.3335C11.3658 10.3941 11.5956 10.5602 11.7405 10.7998L20.5478 25.3899C20.845 25.8819 21.3657 26.1794 21.9277 26.1794C21.9277 26.1794 23.0291 26.1794 24.8422 26.182C24.9796 26.182 25.092 26.0661 25.092 25.9244C25.092 25.802 25.0096 25.6964 24.8934 25.6732C24.6112 25.6179 24.344 25.4479 24.1941 25.1993Z",
    fill: "#B9986A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrismaPoint);
export default __webpack_public_path__ + "static/media/prisma-point.08ffccda3a57e52e76c6ec8bc8636b6f.svg";
export { ForwardRef as ReactComponent };